module.exports = __webpack_public_path__ + "img/amansanduja.490acefb.jpeg";